import React from "react";

const Loader = () => (
  <div style={styles.overlay}>
    <div style={styles.spinner}></div>
  </div>
);

const styles = {
  overlay: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    padding: "40px 0",
  },
  spinner: {
    width: 40,
    height: 40,
    border: "4px solid #f0f0f0",
    borderTop: "4px solid #6c63ff",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
};

// Inject keyframes once
const styleTag = document.createElement("style");
styleTag.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
document.head.appendChild(styleTag);

export default Loader;
